/* eslint-disable max-lines */
export enum PredominantUse {
  COMMERCIAL = 'commercial',
  INDUSTRIAL = 'industrial',
  INSTITUTIONAL = 'institutional',
  RESIDENTIAL_MULTI_FAMILY = 'residential_multi_family',
  RESIDENTIAL_SINGLE_FAMILY = 'residential_single_family',
  OTHER = 'other',
}

export const convertPredominantUse = (type: PredominantUse): string => {
  switch (type) {
    case PredominantUse.RESIDENTIAL_SINGLE_FAMILY:
      return 'Residencial Unifamiliar';
    case PredominantUse.RESIDENTIAL_MULTI_FAMILY:
      return 'Residencial Multifamiliar';
    case PredominantUse.COMMERCIAL:
      return 'Comercial';
    case PredominantUse.INDUSTRIAL:
      return 'Industrial';
    case PredominantUse.INSTITUTIONAL:
      return 'Institucional';
    case PredominantUse.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum UrbanInfrastructure {
  POTABLE_WATER = 'potable_water',
  ELECTRICITY = 'electricity',
  STORM_SEWER = 'storm_sewer',
  SANITARY_SEWER = 'sanitary_sewer',
  GAS_SUPPLY = 'gas_supply',
  PUBLIC_LIGHTING = 'public_lighting',
  PAVING = 'paving',
  TELEPHONE = 'telephone',
}

export const convertUrbanInfrastructure = (
  type: UrbanInfrastructure
): string => {
  switch (type) {
    case UrbanInfrastructure.POTABLE_WATER:
      return 'Água Potável';
    case UrbanInfrastructure.SANITARY_SEWER:
      return 'Esgoto Sanitário';
    case UrbanInfrastructure.ELECTRICITY:
      return 'Energia Elétrica';
    case UrbanInfrastructure.TELEPHONE:
      return 'Telefone';
    case UrbanInfrastructure.PAVING:
      return 'Pavimentação';
    case UrbanInfrastructure.STORM_SEWER:
      return 'Esgoto Pluvial';
    case UrbanInfrastructure.GAS_SUPPLY:
      return 'Gás Canalizado';
    case UrbanInfrastructure.PUBLIC_LIGHTING:
      return 'Iluminação Pública';
    default:
      return '';
  }
};

export enum UnitInfrastructure {
  POTABLE_WATER = 'potable_water',
  ELECTRICITY = 'electricity',
  STORM_SEWER = 'storm_sewer',
  SANITARY_SEWER = 'sanitary_sewer',
  PUBLIC_LIGHTING = 'public_lighting',
  PAVING = 'paving',
  TELEPHONE = 'telephone',
  OTHER = 'other',
}

export const convertUnitInfrastructure = (type: UnitInfrastructure): string => {
  switch (type) {
    case UnitInfrastructure.POTABLE_WATER:
      return 'Água Potável';
    case UnitInfrastructure.SANITARY_SEWER:
      return 'Esgoto Sanitário';
    case UnitInfrastructure.ELECTRICITY:
      return 'Energia Elétrica';
    case UnitInfrastructure.TELEPHONE:
      return 'Telefone';
    case UnitInfrastructure.PAVING:
      return 'Pavimentação';
    case UnitInfrastructure.STORM_SEWER:
      return 'Esgoto Pluvial';
    case UnitInfrastructure.PUBLIC_LIGHTING:
      return 'Iluminação Pública';
    case UnitInfrastructure.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum Improvements {
  NONE = 'none',
  POTABLE_WATER = 'potable_water',
  RETAINING_WALLS = 'retaining_walls',
  ELECTRICITY = 'electricity',
  STORM_SEWER = 'storm_sewer',
  SANITARY_SEWER = 'sanitary_sewer',
  PUBLIC_LIGHTING = 'public_lighting',
  PAVING = 'paving',
  APPROVED_PROJECT = 'approved_project',
  EARTHWORKS = 'earthworks',
  OTHER = 'other',
}

export const convertImprovements = (type: Improvements): string => {
  switch (type) {
    case Improvements.RETAINING_WALLS:
      return 'Contenção';
    case Improvements.EARTHWORKS:
      return 'Terraplanagem';
    case Improvements.PAVING:
      return 'Pavimentação';
    case Improvements.SANITARY_SEWER:
      return 'Esgoto Sanitário';
    case Improvements.STORM_SEWER:
      return 'Esgoto Pluvial';
    case Improvements.POTABLE_WATER:
      return 'Água Potável';
    case Improvements.ELECTRICITY:
      return 'Energia Elétrica';
    case Improvements.PUBLIC_LIGHTING:
      return 'Iluminação';
    case Improvements.APPROVED_PROJECT:
      return 'Projeto Aprovado';
    case Improvements.NONE:
      return 'Não Possui Benfeitorias';
    case Improvements.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum PublicService {
  WASTE_COLLECTION = 'waste_collection',
  COMMERCIAL_AREA = 'commercial_area',
  EDUCATION = 'education',
  BANKING_NETWORK = 'banking_network',
  HEALTHCARE = 'healthcare',
  SECURITY = 'security',
  PUBLIC_TRANSPORT = 'public_transport',
  LEISURE = 'leisure',
  OTHER = 'other',
}

export const convertPublicService = (type: PublicService): string => {
  switch (type) {
    case PublicService.WASTE_COLLECTION:
      return 'Coleta de Lixo';
    case PublicService.PUBLIC_TRANSPORT:
      return 'Transporte Coletivo';
    case PublicService.COMMERCIAL_AREA:
      return 'Comércio';
    case PublicService.BANKING_NETWORK:
      return 'Rede Bancária';
    case PublicService.EDUCATION:
      return 'Educação';
    case PublicService.HEALTHCARE:
      return 'Saúde';
    case PublicService.SECURITY:
      return 'Segurança';
    case PublicService.LEISURE:
      return 'Lazer';
    case PublicService.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum BuildingStandard {
  HIGH_LUXURY = 'high_luxury',
  HIGH_PREDOMINANT = 'high_predominant',
  STANDARD_WITH_HIGH_FEATURES = 'standard_with_high_features',
  STANDARD_PREDOMINANT = 'standard_predominant',
  STANDARD_WITH_LOW_FEATURES = 'standard_with_low_features',
  LOW = 'low',
  MINIMAL = 'minimal',
}

export const convertBuildingStandard = (type: BuildingStandard): string => {
  switch (type) {
    case BuildingStandard.HIGH_LUXURY:
      return 'Alto (superior, luxo)';
    case BuildingStandard.HIGH_PREDOMINANT:
      return 'Alto (por predominância)';
    case BuildingStandard.STANDARD_WITH_HIGH_FEATURES:
      return 'Normal (com aspectos de alto)';
    case BuildingStandard.STANDARD_PREDOMINANT:
      return 'Normal (forte predominância)';
    case BuildingStandard.STANDARD_WITH_LOW_FEATURES:
      return 'Normal (com aspectos de baixo)';
    case BuildingStandard.LOW:
      return 'Baixo';
    case BuildingStandard.MINIMAL:
      return 'Mínimo';
    default:
      return '';
  }
};

export enum PositiveInfluence {
  NONE = 'none',
  CLUBS = 'clubs',
  COMMERCIAL_AREA = 'commercial_area',
  ENTERPRISES = 'enterprises',
  METRO_TRAIN_STATION = 'metro_train_station',
  INDUSTRY = 'industry',
  WATERFRONT = 'waterfront',
  SHOPPING_CENTER = 'shopping_center',
  OTHER = 'other',
}

export const convertPositiveInfluence = (type: PositiveInfluence): string => {
  switch (type) {
    case PositiveInfluence.NONE:
      return 'Sem Destaque';
    case PositiveInfluence.SHOPPING_CENTER:
      return 'Shopping';
    case PositiveInfluence.COMMERCIAL_AREA:
      return 'Comércio';
    case PositiveInfluence.WATERFRONT:
      return 'Orla';
    case PositiveInfluence.METRO_TRAIN_STATION:
      return 'Estação de Metrô/Trem';
    case PositiveInfluence.INDUSTRY:
      return 'Indústria';
    case PositiveInfluence.CLUBS:
      return 'Clubes';
    case PositiveInfluence.ENTERPRISES:
      return 'Empreendimentos';
    case PositiveInfluence.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum NegativeInfluence {
  NONE = 'none',
  SLUM_AREA = 'slum_area',
  FLOOD_RISK_AREA = 'flood_risk_area',
  LANDFILL = 'landfill',
  ENTERPRISE = 'enterprise',
  SEWAGE_TREATMENT_PLANT = 'sewage_treatment_plant',
  STREET_MARKET = 'street_market',
  INDUSTRY = 'industry',
  PRISON = 'prison',
  SUBSTANDARD_HOUSING = 'substandard_housing',
  TELECOM_TOWER = 'telecom_tower',
  OTHER = 'other',
}

export const convertNegativeInfluence = (type: NegativeInfluence): string => {
  switch (type) {
    case NegativeInfluence.NONE:
      return 'Sem Destaque';
    case NegativeInfluence.SLUM_AREA:
      return 'Área de Desmoronamento';
    case NegativeInfluence.LANDFILL:
      return 'Aterro Sanitário/Lixão';
    case NegativeInfluence.SEWAGE_TREATMENT_PLANT:
      return 'Estação de Tratamento de Esgoto';
    case NegativeInfluence.SUBSTANDARD_HOUSING:
      return 'Subhabitação';
    case NegativeInfluence.TELECOM_TOWER:
      return 'Torre Telefônica ou de Energia';
    case NegativeInfluence.INDUSTRY:
      return 'Indústria';
    case NegativeInfluence.FLOOD_RISK_AREA:
      return 'Área Inundável';
    case NegativeInfluence.PRISON:
      return 'Presídios';
    case NegativeInfluence.STREET_MARKET:
      return 'Feira Livre';
    case NegativeInfluence.ENTERPRISE:
      return 'Empreendimento';
    case NegativeInfluence.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum AccessRoad {
  ARTERIAL = 'arterial',
  COLLECTOR = 'collector',
  LOCAL = 'local',
  HIGHWAY = 'highway',
  VICINAL = 'vicinal',
  OTHER = 'other',
}

export const convertAccessRoad = (type: AccessRoad): string => {
  switch (type) {
    case AccessRoad.ARTERIAL:
      return 'Arterial ou Principal';
    case AccessRoad.COLLECTOR:
      return 'Coletora ou Secundária';
    case AccessRoad.LOCAL:
      return 'Local';
    case AccessRoad.HIGHWAY:
      return 'Rodovia';
    case AccessRoad.VICINAL:
      return 'Vicinal';
    case AccessRoad.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum UrbanContext {
  CENTRAL = 'central',
  NON_CENTRAL = 'non_central',
  PERIPHERAL = 'peripheral',
  NOT_IN_URBAN_GRID = 'not_in_urban_grid',
  OTHER = 'other',
}

export const convertUrbanContext = (type: UrbanContext): string => {
  switch (type) {
    case UrbanContext.CENTRAL:
      return 'Região Central';
    case UrbanContext.NON_CENTRAL:
      return 'Região Não Central';
    case UrbanContext.PERIPHERAL:
      return 'Ocupação Periférica/Suburbana';
    case UrbanContext.NOT_IN_URBAN_GRID:
      return 'Não inserido na malha';
    case UrbanContext.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum InspectionType {
  INTERNAL_AND_EXTERNAL = 'internal_and_external',
  EXTERNAL_ONLY = 'external_only',
  NOT_PERFORMED = 'not_performed',
}

export const convertInspectionType = (type: InspectionType): string => {
  switch (type) {
    case InspectionType.INTERNAL_AND_EXTERNAL:
      return 'Interna e Externa';
    case InspectionType.EXTERNAL_ONLY:
      return 'Somente Externa';
    case InspectionType.NOT_PERFORMED:
      return 'Não Realizada';
    default:
      return '';
  }
};

export enum PreservationState {
  UNDER_CONSTRUCTION = 'under_construction',
  GOOD_AS_NEW = 'good_as_new',
  GOOD_USED = 'good_used',
  REGULAR_MINOR_REPAIRS = 'regular_minor_repairs',
  REGULAR_MAJOR_REPAIRS = 'regular_major_repairs',
  POOR = 'poor',
}

export const convertPreservationState = (type: PreservationState): string => {
  switch (type) {
    case PreservationState.UNDER_CONSTRUCTION:
      return 'Em Construção ou na Planta';
    case PreservationState.GOOD_AS_NEW:
      return 'Bom (aparência de novo)';
    case PreservationState.GOOD_USED:
      return 'Bom (aparência de usado)';
    case PreservationState.REGULAR_MINOR_REPAIRS:
      return 'Regular (reparos simples)';
    case PreservationState.REGULAR_MAJOR_REPAIRS:
      return 'Regular (reparos importantes)';
    case PreservationState.POOR:
      return 'Ruim';
    default:
      return '';
  }
};

export enum ApartmentPropertyUse {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'commercial',
  INSTITUTIONAL = 'institutional',
  OTHER = 'other',
}

export const convertApartmentPropertyUse = (
  type: ApartmentPropertyUse
): string => {
  switch (type) {
    case ApartmentPropertyUse.RESIDENTIAL:
      return 'Residencial';
    case ApartmentPropertyUse.COMMERCIAL:
      return 'Residencial/ Comercial/ Institucional';
    case ApartmentPropertyUse.INSTITUTIONAL:
      return 'Comercial/Institucional';
    case ApartmentPropertyUse.OTHER:
      return 'Outro';
    default:
      return '';
  }
};

export enum ApartmentDestination {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'commercial',
  MIXED_USE = 'mixed_use',
  OTHER = 'other',
}

export const convertApartmentDestination = (
  type: ApartmentDestination
): string => {
  switch (type) {
    case ApartmentDestination.RESIDENTIAL:
      return 'Residencial';
    case ApartmentDestination.COMMERCIAL:
      return 'Comercial/Institucional';
    case ApartmentDestination.MIXED_USE:
      return 'Misto';
    case ApartmentDestination.OTHER:
      return 'Outro';
    default:
      return '';
  }
};

export enum HouseLotPropertyUse {
  RESIDENTIAL_COMMERCIAL_INSTITUTIONAL = 'residential_commercial_institutional',
  COMMERCIAL_INSTITUTIONAL = 'commercial_institutional',
  RESIDENTIAL_SINGLE_FAMILY = 'residential_single_family',
  RESIDENTIAL_MULTI_FAMILY = 'residential_multi_family',
  INDUSTRIAL = 'industrial',
  INDUSTRIAL_COMMERCIAL_INSTITUTIONAL = 'industrial_commercial_institutional',
  OTHER = 'other',
}

export const convertHouseLotPropertyUse = (
  type: HouseLotPropertyUse
): string => {
  switch (type) {
    case HouseLotPropertyUse.RESIDENTIAL_COMMERCIAL_INSTITUTIONAL:
      return 'Residencial/Comercial/Institucional';
    case HouseLotPropertyUse.COMMERCIAL_INSTITUTIONAL:
      return 'Comercial/Institucional';
    case HouseLotPropertyUse.RESIDENTIAL_SINGLE_FAMILY:
      return 'Residencial Unifamiliar';
    case HouseLotPropertyUse.RESIDENTIAL_MULTI_FAMILY:
      return 'Residencial Multifamiliar';
    case HouseLotPropertyUse.INDUSTRIAL:
      return 'Industrial';
    case HouseLotPropertyUse.INDUSTRIAL_COMMERCIAL_INSTITUTIONAL:
      return 'Industrial/Comercial/Institucional';
    case HouseLotPropertyUse.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum InternalWall {
  STEEL = 'steel',
  MASONRY = 'masonry',
  CONCRETE = 'concrete',
  PLASTER = 'plaster',
  WOOD = 'wood',
  OTHER = 'other',
}

export const convertInternalWall = (type: InternalWall): string => {
  switch (type) {
    case InternalWall.MASONRY:
      return 'Alvenaria';
    case InternalWall.PLASTER:
      return 'Gesso';
    case InternalWall.WOOD:
      return 'Madeira';
    case InternalWall.CONCRETE:
      return 'Concreto';
    case InternalWall.STEEL:
      return 'Aço';
    case InternalWall.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum OccupancyStatus {
  OCCUPIED = 'occupied',
  VACANT = 'vacant',
  NOT_VERIFIED = 'not_verified',
  PREVIOUSLY_OCCUPIED = 'previously_occupied',
  OTHER = 'other',
}

export const convertOccupancyStatus = (type: OccupancyStatus): string => {
  switch (type) {
    case OccupancyStatus.OCCUPIED:
      return 'Ocupado';
    case OccupancyStatus.VACANT:
      return 'Desocupado';
    case OccupancyStatus.NOT_VERIFIED:
      return 'Não Constatado';
    case OccupancyStatus.PREVIOUSLY_OCCUPIED:
      return 'Desocupado (aparentemente foi ocupado)';
    case OccupancyStatus.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum UnitPosition {
  FRONT_CORNER = 'front_corner',
  FRONT_MIDDLE = 'front_middle',
  BACK_CORNER = 'back_corner',
  BACK_MIDDLE = 'back_middle',
  SIDE = 'side',
}

export const convertUnitPosition = (type: UnitPosition): string => {
  switch (type) {
    case UnitPosition.FRONT_CORNER:
      return 'Frente/Canto';
    case UnitPosition.FRONT_MIDDLE:
      return 'Frente/Meio';
    case UnitPosition.BACK_CORNER:
      return 'Fundo/Canto';
    case UnitPosition.BACK_MIDDLE:
      return 'Fundo/Meio';
    case UnitPosition.SIDE:
      return 'Lateral';
    default:
      return '';
  }
};

export enum SolarOrientation {
  FAVORABLE = 'favorable',
  UNFAVORABLE = 'unfavorable',
  NEUTRAL = 'neutral',
}

export const convertSolarOrientation = (type: SolarOrientation): string => {
  switch (type) {
    case SolarOrientation.FAVORABLE:
      return 'Favorável';
    case SolarOrientation.UNFAVORABLE:
      return 'Desfavorável';
    case SolarOrientation.NEUTRAL:
      return 'Sem Influência';
    default:
      return '';
  }
};

export enum ViewQuality {
  FAVORABLE = 'favorable',
  UNFAVORABLE = 'unfavorable',
  NEUTRAL = 'neutral',
}

export const convertViewQuality = (type: ViewQuality): string => {
  switch (type) {
    case ViewQuality.FAVORABLE:
      return 'Favorável';
    case ViewQuality.UNFAVORABLE:
      return 'Desfavorável';
    case ViewQuality.NEUTRAL:
      return 'Sem Influência';
    default:
      return '';
  }
};

export enum WetAreaFloorFinish {
  SLATE = 'slate',
  COMMERCIAL_CERAMIC = 'commercial_ceramic',
  EXTRA_CERAMIC = 'extra_ceramic',
  CEMENT = 'cement',
  RUBBER = 'rubber',
  FLOATING_FLOOR = 'floating_floor',
  GRANITINA = 'granitina',
  GRANITE_MARBLE_FIRST_GRADE = 'granite_marble_first_grade',
  GRANITE_MARBLE_SECOND_GRADE = 'granite_marble_second_grade',
  WOOD = 'wood',
  PORCELAIN_FIRST_GRADE = 'porcelain_first_grade',
  PORCELAIN_SECOND_GRADE = 'porcelain_second_grade',
  SAO_TOME_STONE = 'sao_tome_stone',
  VINYL = 'vinyl',
  OTHER = 'other',
}

export const convertWetAreaFloorFinish = (type: WetAreaFloorFinish): string => {
  switch (type) {
    case WetAreaFloorFinish.CEMENT:
      return 'Cimentado';
    case WetAreaFloorFinish.COMMERCIAL_CERAMIC:
      return 'Cerâmica Comercial';
    case WetAreaFloorFinish.SAO_TOME_STONE:
      return 'São Tomé';
    case WetAreaFloorFinish.RUBBER:
      return 'Emborrachado';
    case WetAreaFloorFinish.GRANITINA:
      return 'Granitina';
    case WetAreaFloorFinish.PORCELAIN_FIRST_GRADE:
      return 'Porcelanato 1°';
    case WetAreaFloorFinish.PORCELAIN_SECOND_GRADE:
      return 'Porcelanato 2°';
    case WetAreaFloorFinish.GRANITE_MARBLE_FIRST_GRADE:
      return 'Granito/Mármore 1°';
    case WetAreaFloorFinish.GRANITE_MARBLE_SECOND_GRADE:
      return 'Granito/Mármore 2°';
    case WetAreaFloorFinish.EXTRA_CERAMIC:
      return 'Cerâmica Extra';
    case WetAreaFloorFinish.FLOATING_FLOOR:
      return 'Flutuante';
    case WetAreaFloorFinish.SLATE:
      return 'Ardósia';
    case WetAreaFloorFinish.VINYL:
      return 'Vinílico';
    case WetAreaFloorFinish.WOOD:
      return 'Madeira';
    case WetAreaFloorFinish.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum DryAreaFloorFinish {
  SLATE = 'slate',
  COMMERCIAL_CERAMIC = 'commercial_ceramic',
  EXTRA_CERAMIC = 'extra_ceramic',
  CEMENT = 'cement',
  RUBBER = 'rubber',
  FLOATING_FLOOR = 'floating_floor',
  FORMICA = 'formica',
  GRANITINA = 'granitina',
  GRANITE_MARBLE_FIRST_GRADE = 'granite_marble_first_grade',
  GRANITE_MARBLE_SECOND_GRADE = 'granite_marble_second_grade',
  WOOD = 'wood',
  PORCELAIN_FIRST_GRADE = 'porcelain_first_grade',
  PORCELAIN_SECOND_GRADE = 'porcelain_second_grade',
  SAO_TOME_STONE = 'sao_tome_stone',
  VINYL = 'vinyl',
  OTHER = 'other',
}

export const convertDryAreaFloorFinish = (type: DryAreaFloorFinish): string => {
  switch (type) {
    case DryAreaFloorFinish.CEMENT:
      return 'Cimentado';
    case DryAreaFloorFinish.COMMERCIAL_CERAMIC:
      return 'Cerâmica Comercial';
    case DryAreaFloorFinish.SAO_TOME_STONE:
      return 'São Tomé';
    case DryAreaFloorFinish.RUBBER:
      return 'Emborrachado';
    case DryAreaFloorFinish.GRANITINA:
      return 'Granitina';
    case DryAreaFloorFinish.PORCELAIN_FIRST_GRADE:
      return 'Porcelanato 1°';
    case DryAreaFloorFinish.PORCELAIN_SECOND_GRADE:
      return 'Porcelanato 2°';
    case DryAreaFloorFinish.GRANITE_MARBLE_FIRST_GRADE:
      return 'Granito/Mármore 1°';
    case DryAreaFloorFinish.GRANITE_MARBLE_SECOND_GRADE:
      return 'Granito/Mármore 2°';
    case DryAreaFloorFinish.EXTRA_CERAMIC:
      return 'Cerâmica Extra';
    case DryAreaFloorFinish.FLOATING_FLOOR:
      return 'Flutuante';
    case DryAreaFloorFinish.SLATE:
      return 'Ardósia';
    case DryAreaFloorFinish.VINYL:
      return 'Vinílico';
    case DryAreaFloorFinish.WOOD:
      return 'Madeira';
    case DryAreaFloorFinish.FORMICA:
      return 'Formicado';
    case DryAreaFloorFinish.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum WetAreaWallFinish {
  SLATE = 'slate',
  TILE = 'tile',
  COMMERCIAL_CERAMIC = 'commercial_ceramic',
  EXTRA_CERAMIC = 'extra_ceramic',
  CEMENT = 'cement',
  RUBBER = 'rubber',
  FLOATING_FLOOR = 'floating_floor',
  FORMICA = 'formica',
  GRAFIATO = 'grafiato',
  GRANITINA = 'granitina',
  GRANITE_MARBLE_FIRST_GRADE = 'granite_marble_first_grade',
  GRANITE_MARBLE_SECOND_GRADE = 'granite_marble_second_grade',
  WOOD = 'wood',
  PAINT_OR_TEXTURE = 'paint_or_texture',
  PORCELAIN_FIRST_GRADE = 'porcelain_first_grade',
  PORCELAIN_SECOND_GRADE = 'porcelain_second_grade',
  SAO_TOME_STONE = 'sao_tome_stone',
  VINYL = 'vinyl',
  OTHER = 'other',
}

export const convertWetAreaWallFinish = (type: WetAreaWallFinish): string => {
  switch (type) {
    case WetAreaWallFinish.CEMENT:
      return 'Cimentado';
    case WetAreaWallFinish.COMMERCIAL_CERAMIC:
      return 'Cerâmica Comercial';
    case WetAreaWallFinish.SAO_TOME_STONE:
      return 'São Tomé';
    case WetAreaWallFinish.RUBBER:
      return 'Emborrachado';
    case WetAreaWallFinish.GRANITINA:
      return 'Granitina';
    case WetAreaWallFinish.PORCELAIN_FIRST_GRADE:
      return 'Porcelanato 1°';
    case WetAreaWallFinish.PORCELAIN_SECOND_GRADE:
      return 'Porcelanato 2°';
    case WetAreaWallFinish.GRANITE_MARBLE_FIRST_GRADE:
      return 'Granito/Mármore 1°';
    case WetAreaWallFinish.GRANITE_MARBLE_SECOND_GRADE:
      return 'Granito/Mármore 2°';
    case WetAreaWallFinish.EXTRA_CERAMIC:
      return 'Cerâmica Extra';
    case WetAreaWallFinish.FLOATING_FLOOR:
      return 'Flutuante';
    case WetAreaWallFinish.TILE:
      return 'Azulejo';
    case WetAreaWallFinish.SLATE:
      return 'Ardósia';
    case WetAreaWallFinish.VINYL:
      return 'Vinílico';
    case WetAreaWallFinish.WOOD:
      return 'Madeira';
    case WetAreaWallFinish.FORMICA:
      return 'Formicado';
    case WetAreaWallFinish.PAINT_OR_TEXTURE:
      return 'Pintura/Textura';
    case WetAreaWallFinish.GRAFIATO:
      return 'Grafiato';
    case WetAreaWallFinish.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum BuildingImplantation {
  CONDOMINIUM = 'condominium',
  PART_OF_CONDOMINIUM = 'part_of_condominium',
  NON_CONDOMINIUM_PROJECT = 'non_condominium_project',
}

export const convertBuildingImplantation = (
  type: BuildingImplantation
): string => {
  switch (type) {
    case BuildingImplantation.CONDOMINIUM:
      return 'Condomínio';
    case BuildingImplantation.PART_OF_CONDOMINIUM:
      return 'Condomínio (Parte de Outro Condomínio)';
    case BuildingImplantation.NON_CONDOMINIUM_PROJECT:
      return 'Condomínio (Empreend. Não Condominial)';
    default:
      return '';
  }
};

export enum RoofTopCharacterization {
  NOT_IN_USE = 'not_in_use',
  INDIVIDUAL = 'individual',
  COLLECTIVE = 'collective',
  INDIVIDUAL_AND_COLLECTIVE = 'individual_and_collective',
  OTHER = 'other',
}

export const convertRoofTopCharacterization = (
  type: RoofTopCharacterization
): string => {
  switch (type) {
    case RoofTopCharacterization.INDIVIDUAL:
      return 'Cobertura Individual';
    case RoofTopCharacterization.COLLECTIVE:
      return 'Uso Coletivo';
    case RoofTopCharacterization.INDIVIDUAL_AND_COLLECTIVE:
      return 'Uso Individual e Coletivo';
    case RoofTopCharacterization.NOT_IN_USE:
      return 'Sem Utilização';
    case RoofTopCharacterization.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum EstimatedAge {
  OFF_PLAN = 'off_plan',
  UP_TO_5 = 'up_to_5',
  FROM_5_TO_10 = 'from_5_to_10',
  FROM_10_TO_20 = 'from_10_to_20',
  FROM_20_TO_50 = 'from_20_to_50',
  FROM_50_TO_100 = 'from_50_to_100',
  OVER_100 = 'over_100',
}

export const convertEstimatedAge = (type: EstimatedAge): string => {
  switch (type) {
    case EstimatedAge.OFF_PLAN:
      return 'Na Planta';
    case EstimatedAge.UP_TO_5:
      return 'Até 5 anos';
    case EstimatedAge.FROM_5_TO_10:
      return 'De 5 a 10 anos';
    case EstimatedAge.FROM_10_TO_20:
      return 'De 10 a 20 anos';
    case EstimatedAge.FROM_20_TO_50:
      return 'De 20 a 50 anos';
    case EstimatedAge.FROM_50_TO_100:
      return 'De 50 a 100 anos';
    case EstimatedAge.OVER_100:
      return 'Acima de 100 anos';
    default:
      return '';
  }
};

export enum GroundFloorOccupation {
  GARAGES = 'garages',
  LEISURE = 'leisure',
  SHOPS = 'shops',
  PILOTIS = 'pilotis',
  ROOMS = 'rooms',
  RESIDENTIAL_UNITS = 'residential_units',
  OTHER = 'other',
}

export const convertGroundFloorOccupation = (
  type: GroundFloorOccupation
): string => {
  switch (type) {
    case GroundFloorOccupation.SHOPS:
      return 'Lojas';
    case GroundFloorOccupation.ROOMS:
      return 'Salas';
    case GroundFloorOccupation.PILOTIS:
      return 'Pilotis';
    case GroundFloorOccupation.LEISURE:
      return 'Lazer';
    case GroundFloorOccupation.RESIDENTIAL_UNITS:
      return 'Unidades Residenciais';
    case GroundFloorOccupation.GARAGES:
      return 'Garagens';
    case GroundFloorOccupation.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum MainFacadeMaterial {
  ALUMINUM = 'aluminum',
  STEEL = 'steel',
  WOOD = 'wood',
  PVC = 'pvc',
  TEMPERED_GLASS = 'tempered_glass',
  OTHER = 'other',
}

export const convertMainFacadeMaterial = (type: MainFacadeMaterial): string => {
  switch (type) {
    case MainFacadeMaterial.ALUMINUM:
      return 'Alumínio';
    case MainFacadeMaterial.STEEL:
      return 'Ferro';
    case MainFacadeMaterial.TEMPERED_GLASS:
      return 'Vidro Temperado';
    case MainFacadeMaterial.PVC:
      return 'PVC';
    case MainFacadeMaterial.WOOD:
      return 'Madeira';
    case MainFacadeMaterial.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum FacadeFinish {
  NO_FINISH = 'no_finish',
  COMPOSITE_ALUMINUM = 'composite_aluminum',
  SLATE_OR_SIMILAR = 'slate_or_similar',
  HIGH_QUALITY_CERAMIC = 'high_quality_ceramic',
  LOW_QUALITY_CERAMIC = 'low_quality_ceramic',
  CEMENT_PLASTER = 'cement_plaster',
  COBOGO = 'cobogo',
  GRAFIATO = 'grafiato',
  GRANITINA_OR_SIMILAR = 'granitina_or_similar',
  GRANITE_OR_SIMILAR = 'granite_or_similar',
  WOOD_OR_WOOD_LIKE = 'wood_or_wood_like',
  MARBLE_OR_SIMILAR = 'marble_or_similar',
  TILE = 'tile',
  GLASS_CURTAIN_WALL = 'glass_curtain_wall',
  PAINT_TEXTURE = 'paint_texture',
  PORCELAIN = 'porcelain',
  VULCANIZED_OR_LAMINATED = 'vulcanized_or_laminated',
  OTHER = 'other',
}

export const convertFacadeFinish = (type: FacadeFinish): string => {
  switch (type) {
    case FacadeFinish.NO_FINISH:
      return 'Sem Revestimento';
    case FacadeFinish.CEMENT_PLASTER:
      return 'Cimentado';
    case FacadeFinish.PAINT_TEXTURE:
      return 'Pintura/Textura';
    case FacadeFinish.GRAFIATO:
      return 'Grafiato';
    case FacadeFinish.LOW_QUALITY_CERAMIC:
      return 'Cerâmica de Baixa Qualidade';
    case FacadeFinish.SLATE_OR_SIMILAR:
      return 'Ardósia ou Compatível';
    case FacadeFinish.COBOGO:
      return 'Cobogó';
    case FacadeFinish.VULCANIZED_OR_LAMINATED:
      return 'Vulcanizado ou Formicado';
    case FacadeFinish.GRANITINA_OR_SIMILAR:
      return 'Granitina ou Compatível';
    case FacadeFinish.HIGH_QUALITY_CERAMIC:
      return 'Cerâmica Boa Qualidade';
    case FacadeFinish.PORCELAIN:
      return 'Porcelanato';
    case FacadeFinish.WOOD_OR_WOOD_LIKE:
      return 'Madeira ou Emadeirado';
    case FacadeFinish.GRANITE_OR_SIMILAR:
      return 'Granito ou Compatível';
    case FacadeFinish.MARBLE_OR_SIMILAR:
      return 'Mármore ou Compatível';
    case FacadeFinish.COMPOSITE_ALUMINUM:
      return 'Alumínio Composto';
    case FacadeFinish.GLASS_CURTAIN_WALL:
      return 'Pele de Vidro';
    case FacadeFinish.TILE:
      return 'Pastilha';
    case FacadeFinish.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum BuildingAmenity {
  NO_AMENITIES = 'no_amenities',
  CENTRAL_WATER_HEATING = 'central_water_heating',
  SOLAR_HEATING = 'solar_heating',
  AIR_CONDITIONING = 'air_conditioning',
  BUILT_IN_CABINETS = 'built_in_cabinets',
  SPORTS_FIELD = 'sports_field',
  BARBECUE_AREA = 'barbecue_area',
  PRIVATE_BARBECUE_AREA = 'private_barbecue_area',
  SECURITY_EQUIPMENT = 'security_equipment',
  VISITOR_PARKING = 'visitor_parking',
  GENERATOR = 'generator',
  FIREPLACE = 'fireplace',
  MINI_SPORTS_COURT = 'mini_sports_court',
  PILOTIS = 'pilotis',
  SWIMMING_POOL = 'swimming_pool',
  PRIVATE_SWIMMING_POOL = 'private_swimming_pool',
  PLAYGROUND = 'playground',
  ARTESIAN_WELL = 'artesian_well',
  RECEPTION = 'reception',
  TENNIS_COURT = 'tennis_court',
  MULTI_SPORT_COURT = 'multi_sport_court',
  INTERNAL_GAS_NETWORK = 'internal_gas_network',
  LEISURE_ROOMS = 'leisure_rooms',
  PARTY_HALL = 'party_hall',
  SAUNA_SPA = 'sauna_spa',
  PRIVATE_SAUNA_SPA = 'private_sauna_spa',
  OTHER = 'other',
}

export const convertBuildingAmenity = (type: BuildingAmenity): string => {
  switch (type) {
    case BuildingAmenity.SOLAR_HEATING:
      return 'Aquecimento Solar';
    case BuildingAmenity.BUILT_IN_CABINETS:
      return 'Armários Embutidos';
    case BuildingAmenity.AIR_CONDITIONING:
      return 'Ar Condicionado';
    case BuildingAmenity.SPORTS_FIELD:
      return 'Campo de Futebol/Golfe';
    case BuildingAmenity.SECURITY_EQUIPMENT:
      return 'Equipamento de Segurança';
    case BuildingAmenity.VISITOR_PARKING:
      return 'Estacionamento para Visitantes';
    case BuildingAmenity.BARBECUE_AREA:
      return 'Churrasqueira';
    case BuildingAmenity.PRIVATE_BARBECUE_AREA:
      return 'Churrasqueira Privativa';
    case BuildingAmenity.GENERATOR:
      return 'Gerador';
    case BuildingAmenity.FIREPLACE:
      return 'Lareira';
    case BuildingAmenity.INTERNAL_GAS_NETWORK:
      return 'Rede de Gás Interna';
    case BuildingAmenity.MINI_SPORTS_COURT:
      return 'Mini Quadra Esportiva';
    case BuildingAmenity.SWIMMING_POOL:
      return 'Piscina';
    case BuildingAmenity.PRIVATE_SWIMMING_POOL:
      return 'Piscina Privativa';
    case BuildingAmenity.PLAYGROUND:
      return 'Playground';
    case BuildingAmenity.ARTESIAN_WELL:
      return 'Poço Artesiano';
    case BuildingAmenity.RECEPTION:
      return 'Portaria e/ou Guarita';
    case BuildingAmenity.PARTY_HALL:
      return 'Salão de Festas';
    case BuildingAmenity.LEISURE_ROOMS:
      return 'Salas de Lazer';
    case BuildingAmenity.SAUNA_SPA:
      return 'Sauna/Ofurô/Hidromassagem';
    case BuildingAmenity.PRIVATE_SAUNA_SPA:
      return 'Sauna/Ofurô/Hidromassagem Privativa';
    case BuildingAmenity.TENNIS_COURT:
      return 'Quadra de Tênis';
    case BuildingAmenity.MULTI_SPORT_COURT:
      return 'Quadra Poliesportiva';
    case BuildingAmenity.CENTRAL_WATER_HEATING:
      return 'Aquecimento Central de Água';
    case BuildingAmenity.PILOTIS:
      return 'Pilotis';
    case BuildingAmenity.NO_AMENITIES:
      return 'Não Possui Equipamentos';
    case BuildingAmenity.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum BuildingAmenityLot {
  NO_AMENITIES = 'no_amenities',
  CENTRAL_WATER_HEATING = 'central_water_heating',
  SPORTS_FIELD = 'sports_field',
  BARBECUE_AREA = 'barbecue_area',
  SECURITY_EQUIPMENT = 'security_equipment',
  VISITOR_PARKING = 'visitor_parking',
  GENERATOR = 'generator',
  MINI_SPORTS_COURT = 'mini_sports_court',
  SWIMMING_POOL = 'swimming_pool',
  PLAYGROUND = 'playground',
  ARTESIAN_WELL = 'artesian_well',
  RECEPTION = 'reception',
  TENNIS_COURT = 'tennis_court',
  MULTI_SPORT_COURT = 'multi_sport_court',
  INTERNAL_GAS_NETWORK = 'internal_gas_network',
  LEISURE_ROOMS = 'leisure_rooms',
  PARTY_HALL = 'party_hall',
  SAUNA_SPA = 'sauna_spa',
  OTHER = 'other',
}

export const convertBuildingAmenityLot = (type: BuildingAmenityLot): string => {
  switch (type) {
    case BuildingAmenityLot.VISITOR_PARKING:
      return 'Estacionamento para Visitantes';
    case BuildingAmenityLot.RECEPTION:
      return 'Portaria e/ou Guarita';
    case BuildingAmenityLot.PLAYGROUND:
      return 'Playground';
    case BuildingAmenityLot.BARBECUE_AREA:
      return 'Churrasqueira';
    case BuildingAmenityLot.GENERATOR:
      return 'Gerador';
    case BuildingAmenityLot.SWIMMING_POOL:
      return 'Piscina';
    case BuildingAmenityLot.MINI_SPORTS_COURT:
      return 'Mini Quadra Esportiva';
    case BuildingAmenityLot.LEISURE_ROOMS:
      return 'Salas de Lazer';
    case BuildingAmenityLot.SECURITY_EQUIPMENT:
      return 'Equipamento de Segurança';
    case BuildingAmenityLot.CENTRAL_WATER_HEATING:
      return 'Aquecimento Central de Água';
    case BuildingAmenityLot.PARTY_HALL:
      return 'Salão de Festas';
    case BuildingAmenityLot.SAUNA_SPA:
      return 'Sauna/Ofurô/Hidromassagem';
    case BuildingAmenityLot.SPORTS_FIELD:
      return 'Campo de Futebol/Golfe';
    case BuildingAmenityLot.TENNIS_COURT:
      return 'Quadra de Tênis';
    case BuildingAmenityLot.MULTI_SPORT_COURT:
      return 'Quadra Poliesportiva';
    case BuildingAmenityLot.INTERNAL_GAS_NETWORK:
      return 'Rede de Gás Interna';
    case BuildingAmenityLot.ARTESIAN_WELL:
      return 'Poço Artesiano';
    case BuildingAmenityLot.NO_AMENITIES:
      return 'Não Possui Equipamentos';
    case BuildingAmenityLot.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum LandOccupationType {
  ROAD_SYSTEM = 'road_system',
  COMMERCIAL = 'commercial',
  PARKING = 'parking',
  LEISURE = 'leisure',
  VACANT_LOTS = 'vacant_lots',
  BUILDINGS = 'buildings',
  ISOLATED_UNITS = 'isolated_units',
  OTHER = 'other',
}

export const convertLandOccupationType = (type: LandOccupationType): string => {
  switch (type) {
    case LandOccupationType.BUILDINGS:
      return 'Prédios';
    case LandOccupationType.ISOLATED_UNITS:
      return 'Unidades Isoladas';
    case LandOccupationType.LEISURE:
      return 'Lazer';
    case LandOccupationType.PARKING:
      return 'Garagens/Estacionamento';
    case LandOccupationType.ROAD_SYSTEM:
      return 'Arruamento';
    case LandOccupationType.COMMERCIAL:
      return 'Comércio';
    case LandOccupationType.VACANT_LOTS:
      return 'Lotes Vagos';
    case LandOccupationType.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum LotPosition {
  MID_BLOCK = 'mid_block',
  CORNER = 'corner',
  ISOLATED = 'isolated',
  OTHER = 'other',
}

export const convertLotPosition = (type: LotPosition): string => {
  switch (type) {
    case LotPosition.MID_BLOCK:
      return 'Meio de Quadra';
    case LotPosition.CORNER:
      return 'Esquina';
    case LotPosition.ISOLATED:
      return 'Isolado';
    case LotPosition.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum ElevationGrade {
  BELOW = 'below',
  AT_OR_ABOVE = 'at_or_above',
  OTHER = 'other',
}

export const convertElevationGrade = (type: ElevationGrade): string => {
  switch (type) {
    case ElevationGrade.BELOW:
      return 'Abaixo';
    case ElevationGrade.AT_OR_ABOVE:
      return 'Igual ou Acima';
    case ElevationGrade.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum FencingExtent {
  NONE = 'none',
  PARTIAL = 'partial',
  TOTAL = 'total',
}

export const convertFencingExtent = (type: FencingExtent): string => {
  switch (type) {
    case FencingExtent.NONE:
      return 'Não possui';
    case FencingExtent.PARTIAL:
      return 'Parcial';
    case FencingExtent.TOTAL:
      return 'Total';
    default:
      return '';
  }
};

export enum FrontFencing {
  NO_FENCE = 'no_fence',
  WIRE = 'wire',
  RAILING = 'railing',
  WALL = 'wall',
  MESH = 'mesh',
  OTHER = 'other',
}

export const convertFrontFencing = (type: FrontFencing): string => {
  switch (type) {
    case FrontFencing.NO_FENCE:
      return 'Sem Cercamento';
    case FrontFencing.WIRE:
      return 'Arame';
    case FrontFencing.MESH:
      return 'Tela';
    case FrontFencing.RAILING:
      return 'Gradil';
    case FrontFencing.WALL:
      return 'Muro';
    case FrontFencing.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum ImplantationInsertion {
  ISOLATED = 'isolated',
  ISOLATED_NON_CONDOMINIUM_DEVELOPMENT = 'isolated_non_condominium_development',
  CONDOMINIUM = 'condominium',
}

export const convertImplantationInsertion = (
  type: ImplantationInsertion
): string => {
  switch (type) {
    case ImplantationInsertion.ISOLATED:
      return 'Isolado';
    case ImplantationInsertion.ISOLATED_NON_CONDOMINIUM_DEVELOPMENT:
      return 'Isolado Loteamento Não Condominial';
    case ImplantationInsertion.CONDOMINIUM:
      return 'Condomínio';
    default:
      return '';
  }
};

export enum LotPlacement {
  ISOLATED = 'isolated',
  ATTACHED = 'attached',
  SEMI_DETACHED = 'semi_detached',
}

export const convertLotPlacement = (type: LotPlacement): string => {
  switch (type) {
    case LotPlacement.ISOLATED:
      return 'Isolada';
    case LotPlacement.ATTACHED:
      return 'Justaposta';
    case LotPlacement.SEMI_DETACHED:
      return 'Geminada';
    default:
      return '';
  }
};

export enum CeilingType {
  EXPOSED_ROOF = 'exposed_roof',
  PVC_CEILING = 'pvc_ceiling',
  GYPSUM_CEILING = 'gypsum_ceiling',
  PARTICLEBOARD_CEILING = 'particleboard_ceiling',
  WOODEN_CEILING = 'wooden_ceiling',
  METAL_CEILING = 'metal_ceiling',
  OTHER_CEILING = 'other_ceiling',
  SLAB = 'slab',
  OTHER = 'other',
}

export const convertCeilingType = (type: CeilingType): string => {
  switch (type) {
    case CeilingType.EXPOSED_ROOF:
      return 'Telhado Aparente';
    case CeilingType.PVC_CEILING:
      return 'Forro de PVC';
    case CeilingType.GYPSUM_CEILING:
      return 'Forro de Gesso';
    case CeilingType.PARTICLEBOARD_CEILING:
      return 'Forro de Aglomerado';
    case CeilingType.WOODEN_CEILING:
      return 'Forro de Madeira';
    case CeilingType.METAL_CEILING:
      return 'Forro Metálico';
    case CeilingType.OTHER_CEILING:
      return 'Forro Outros';
    case CeilingType.SLAB:
      return 'Laje';
    case CeilingType.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum RoofType {
  FIBER_CEMENT_TILE_NO_SLAB = 'fiber_cement_tile_no_slab',
  METAL_TILE_NO_SLAB = 'metal_tile_no_slab',
  CLAY_TILE_NO_SLAB = 'clay_tile_no_slab',
  CONCRETE_TILE_NO_SLAB = 'concrete_tile_no_slab',
  FIBER_CEMENT_TILE_WITH_SLAB = 'fiber_cement_tile_with_slab',
  METAL_TILE_WITH_SLAB = 'metal_tile_with_slab',
  CLAY_TILE_WITH_SLAB = 'clay_tile_with_slab',
  CONCRETE_TILE_WITH_SLAB = 'concrete_tile_with_slab',
  WATERPROOFED_SLAB = 'waterproofed_slab',
  OTHER = 'other',
}

export const convertRoofType = (type: RoofType): string => {
  switch (type) {
    case RoofType.FIBER_CEMENT_TILE_NO_SLAB:
      return 'Telha de Fibrocimento, sem Laje';
    case RoofType.METAL_TILE_NO_SLAB:
      return 'Telha Metálica, sem Laje';
    case RoofType.CLAY_TILE_NO_SLAB:
      return 'Telha de Barro, sem Laje';
    case RoofType.CONCRETE_TILE_NO_SLAB:
      return 'Telha de Concreto, sem Laje';
    case RoofType.FIBER_CEMENT_TILE_WITH_SLAB:
      return 'Telha de Fibrocimento, com Laje';
    case RoofType.METAL_TILE_WITH_SLAB:
      return 'Telha Metálica, com Laje';
    case RoofType.CLAY_TILE_WITH_SLAB:
      return 'Telha de Barro, com Laje';
    case RoofType.CONCRETE_TILE_WITH_SLAB:
      return 'Telha de Concreto, com Laje';
    case RoofType.WATERPROOFED_SLAB:
      return 'Laje Impermeabilizada';
    case RoofType.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum LotShape {
  SQUARE = 'square',
  RECTANGULAR = 'rectangular',
  TRIANGULAR = 'triangular',
  TRAPEZOIDAL = 'trapezoidal',
  IRREGULAR = 'irregular',
  OTHER = 'other',
}

export const convertLotShape = (type: LotShape): string => {
  switch (type) {
    case LotShape.SQUARE:
      return 'Quadrado';
    case LotShape.RECTANGULAR:
      return 'Retangular';
    case LotShape.TRIANGULAR:
      return 'Triangular';
    case LotShape.TRAPEZOIDAL:
      return 'Trapezoidal';
    case LotShape.IRREGULAR:
      return 'Irregular';
    case LotShape.OTHER:
      return 'Outros';
    default:
      return '';
  }
};

export enum LotSlope {
  FLAT = 'flat',
  UPHILL_TO_BACK = 'uphill_to_back',
  DOWNHILL_TO_BACK = 'downhill_to_back',
}

export const convertLotSlope = (type: LotSlope): string => {
  switch (type) {
    case LotSlope.FLAT:
      return 'Plano';
    case LotSlope.UPHILL_TO_BACK:
      return 'Aclive para o Fundo';
    case LotSlope.DOWNHILL_TO_BACK:
      return 'Declive para o Fundo';
    default:
      return '';
  }
};

export enum UsageRestrictionLevel {
  HIGH = 'high',
  NO_HIGHLIGHT = 'no_highlight',
  LOW = 'low',
}

export const convertUsageRestrictionLevel = (
  type: UsageRestrictionLevel
): string => {
  switch (type) {
    case UsageRestrictionLevel.HIGH:
      return 'Alto';
    case UsageRestrictionLevel.NO_HIGHLIGHT:
      return 'Sem Destaque';
    case UsageRestrictionLevel.LOW:
      return 'Baixo';
    default:
      return '';
  }
};

export enum SurfaceType {
  DRY = 'dry',
  CAN_FLOOD = 'can_flood',
  MARSHY = 'marshy',
}

export const convertSurfaceType = (type: SurfaceType): string => {
  switch (type) {
    case SurfaceType.DRY:
      return 'Seco';
    case SurfaceType.CAN_FLOOD:
      return 'Alagável';
    case SurfaceType.MARSHY:
      return 'Brejoso';
    default:
      return '';
  }
};

export enum CheckboxTitle {
  predominant_uses = 'predominant_uses',
  urban_infrastructure = 'urban_infrastructure',
  public_services = 'public_services',
  positive = 'positive',
  negative = 'negative',
  internal_wall = 'internal_wall',
  floor_material = 'floor_material',
  wall_material = 'wall_material',
  dry_floor_material = 'dry_floor_material',
  implantation = 'implantation',
  roof_characterization = 'roof_characterization',
  ground_floor_occupation = 'ground_floor_occupation',
  floor_finish = 'floor_finish',
  wall_finish = 'wall_finish',
  frames_main_facade = 'main_facade',
  frames_other_facades = 'other_facades',
  main_facade = 'main_facade',
  secondary_facade = 'secondary_facade',
  unit_equipments = 'equipments',
  land_occupation = 'land_occupation',
  infrastructure = 'infrastructure',
  front = 'front',
  side_and_back = 'side_and_back',
  fencing_front = 'fencing_front',
  fencing_side_and_back = 'fencing_side_and_back',
  main_vocation = 'main_vocation',
}

export const convertCheckboxTitle = (type: CheckboxTitle): string => {
  switch (type) {
    case CheckboxTitle.predominant_uses:
      return 'Usos Predominantes';
    case CheckboxTitle.urban_infrastructure:
      return 'Infraestrutura Urbana';
    case CheckboxTitle.public_services:
      return 'Serviços Públicos e Comunitários';
    case CheckboxTitle.positive:
      return 'Valorizantes';
    case CheckboxTitle.negative:
      return 'Desvalorizantes';
    case CheckboxTitle.internal_wall:
      return 'Paredes';
    case CheckboxTitle.floor_material:
      return 'Áreas Molhadas - Pisos';
    case CheckboxTitle.wall_material:
      return 'Áreas Molhadas - Paredes';
    case CheckboxTitle.implantation:
    case CheckboxTitle.dry_floor_material:
      return 'Áreas Secas - Pisos';
      return 'Implantação';
    case CheckboxTitle.roof_characterization:
      return 'Caracterização da Cobertura';
    case CheckboxTitle.ground_floor_occupation:
      return 'Ocupação de Térreo';
    case CheckboxTitle.floor_finish:
      return 'Acabamentos - Piso';
    case CheckboxTitle.wall_finish:
      return 'Acabamentos - Parede';
    case CheckboxTitle.frames_main_facade:
      return 'Esquadrias - Fachada Principal';
    case CheckboxTitle.frames_other_facades:
      return 'Esquadrias - Demais Fachadas';
    case CheckboxTitle.main_facade:
      return 'Fachadas - Principal';
    case CheckboxTitle.secondary_facade:
      return 'Fachadas - Demais';
    case CheckboxTitle.unit_equipments:
      return 'Equipamentos da Unidade';
    case CheckboxTitle.land_occupation:
      return 'Empreendimento -Ocupação do Terreno';
    case CheckboxTitle.infrastructure:
      return 'Empreendimento - Infraestrutura';
    case CheckboxTitle.front:
      return 'Frente';
    case CheckboxTitle.side_and_back:
      return 'Lateral/Fundos';
    case CheckboxTitle.fencing_front:
      return 'Cercamento - Frente';
    case CheckboxTitle.fencing_side_and_back:
      return 'Cercamento - Lateral/Fundos';
    case CheckboxTitle.main_vocation:
      return 'Vocação Principal';
    default:
      return '';
  }
};
